import { createContext, useContext } from "react";

type TenantClientSelectorContextType = {
  open: boolean;
  setOpen: (open: boolean) => void;

  openedFromClientTrigger: boolean;
  setOpenedFromClientTrigger: (value: boolean) => void;
}
export const TenantClientSelectorContext = createContext<
  TenantClientSelectorContextType | undefined
>(undefined);

export const useTenantClientSelector = () => {
  const context = useContext(TenantClientSelectorContext);
  if (!context) {
    throw new Error(
      "useTenantClientSelector must be used within TenantClientSelectorProvider",
    );
  }
  return context;
};
